import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { loadBusinessUserSuccess } from '@app/core/store/businessUser/businessUser.actions';
import { BusinessUserState } from '@app/core/store/businessUser/businessUser.reducer';
import type { IBusinessSale, WebPushSubscription } from '@interfaces';
import { Store } from '@ngrx/store';
import { LanguageService } from '@services';
import type { ApiResponse } from '@shared';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BusinessPortalService {
  constructor(
    private http: HttpClient,
    private languageService: LanguageService,
    private _store: Store<{ businessUser: BusinessUserState }>,
  ) {}

  getBusinessDetail(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('/v1/business-portal/detail');
  }

  scanInvoice(qrData: string, businessId: string): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`/v1/business-portal/scan-invoice/${businessId}`, { qrData });
  }

  listOfClaims(params: any, lang: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('/v1/business-portal/list-of-realization', {
      headers: { lang },
      params,
    });
  }

  createSale(data: IBusinessSale): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/v1/business-portal/create-sale', data);
  }

  updateSale(data: IBusinessSale): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/v1/business-portal/update-sale', data);
  }

  getSale(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('/v1/business-portal/get-sale');
  }

  exportListOfClaims(params: any) {
    const options = {
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
      params,
      headers: { lang: this.languageService.getCurrentLang() },
    };
    return this.http.post<HttpResponse<Blob>>('/v1/business-portal/export-list-of-realization', params, options);
  }

  notificationDetail(sub: WebPushSubscription): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/v1/business-portal/notificationdetail', { sub });
  }

  updateLastSeen(id: string): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/business-portal/last-seen/${id}`, { lastSeen: new Date() });
  }

  setBusinessDetails(data: any) {
    this._store.dispatch(loadBusinessUserSuccess({ businessUser: data }));
  }
}
